export default "__VITE_ASSET__Du9WrayO__"